import {
    RouteLocationInterface,
    RouteHttpVerb,
    RouteResponseInterface,
    RouteRequestInterface,
    RouteParamsInterface
} from "@vadimages-wp/utils";

export const locationRestSettingsSet: RouteLocationInterface = {
    path: "/settings",
    method: RouteHttpVerb.POST
};

export type RequestRouteSettingsSet = RouteRequestInterface;

export type ParamsRouteSettingsSet = RouteParamsInterface;

export interface ResponseRouteSettingsSet extends RouteResponseInterface {

}
